(function () {
  var root = document.getElementById('hke');
  if (!root) return;
  var out = document.getElementById('hke-out');
  var data = [];
  try { data = JSON.parse(document.getElementById('hke-data').textContent); } catch (err) { data = []; }

  var VEN = {
    'cardiff':   { name: 'Cardiff Sauna Village', c: '#db673a', ink: '#ffffff', key: 'cardiff', addr: 'Meanwhile House, Curran Embankment, Cardiff CF10 5DY' },
    'sandy bay': { name: 'Sandy Bay', c: '#4a9060', ink: '#ffffff', key: 'sandy', addr: 'Hi-Tide Car Park, Mackworth Road, Porthcawl' },
    'both':      { name: 'Cardiff and Sandy Bay', c: '#fbbf39', ink: '#242424', key: 'both', addr: '' }
  };
  var NONE = { name: '', c: '#242424', ink: '#ffffff', key: 'none', addr: '' };
  var DOW = { sunday: 0, monday: 1, tuesday: 2, wednesday: 3, thursday: 4, friday: 5, saturday: 6 };
  var DAYS = ['Sunday', 'Monday', 'Tuesday', 'Wednesday', 'Thursday', 'Friday', 'Saturday'];
  var MONTHS = ['January', 'February', 'March', 'April', 'May', 'June', 'July', 'August', 'September', 'October', 'November', 'December'];
  var ICONS = {
    flame: '<path d="M12 3c1 3.5 5 5.5 5 10a5 5 0 0 1-10 0c0-2 .9-3.4 2-4.5.2 1.6.9 2.4 1.8 2.8C11 8.5 10.5 5.5 12 3z"/>',
    wave: '<path d="M2 9c2-2 4-2 6 0s4 2 6 0 4-2 6 0M2 14c2-2 4-2 6 0s4 2 6 0 4-2 6 0M2 19c2-2 4-2 6 0s4 2 6 0 4-2 6 0"/>',
    sound: '<path d="M4 10v4M8 6v12M12 3v18M16 7v10M20 10v4"/>',
    run: '<circle cx="12" cy="13.5" r="7.5"/><path d="M12 13.5V9.5M9.5 2.5h5M12 2.5v3.5"/>',
    moon: '<path d="M20 14.5A8 8 0 1 1 9.5 4a6.5 6.5 0 0 0 10.5 10.5z"/>',
    leaf: '<path d="M5 19c0-9 5-14 14-14 0 9-5 14-14 14zM5 19l7-7"/>',
    sauna: '<path d="M3 20h18M5 20v-9l7-5.5 7 5.5v9M9 3c1 1 1 2 0 3M13 2c1 1 1 2 0 3"/>',
    star: '<path d="M12 3l2.6 5.6 6.1.7-4.5 4.2 1.2 6L12 16.5 6.6 19.5l1.2-6L3.3 9.3l6.1-.7z"/>',
    heart: '<path d="M12 20s-7-4.4-7-10a4 4 0 0 1 7-2.6A4 4 0 0 1 19 10c0 5.6-7 10-7 10z"/>',
    yoga: '<circle cx="12" cy="4.5" r="2"/><path d="M12 7v6M6 10l6 3 6-3M8 20l4-7 4 7"/>'
  };
  var UI = {
    cal: '<svg viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2" stroke-linecap="round" aria-hidden="true"><rect x="3" y="5" width="18" height="16" rx="2"/><path d="M3 10h18M8 3v4M16 3v4"/></svg>',
    share: '<svg viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2" stroke-linecap="round" stroke-linejoin="round" aria-hidden="true"><circle cx="18" cy="5" r="3"/><circle cx="6" cy="12" r="3"/><circle cx="18" cy="19" r="3"/><path d="M8.6 13.5l6.8 4M15.4 6.5l-6.8 4"/></svg>'
  };
  function icon(n) { return '<svg viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="1.9" stroke-linecap="round" stroke-linejoin="round" aria-hidden="true">' + (ICONS[n] || ICONS.star) + '</svg>'; }
  function esc(s) { return String(s == null ? '' : s).replace(/[&<>"']/g, function (c) { return { '&': '&amp;', '<': '&lt;', '>': '&gt;', '"': '&quot;', "'": '&#39;' }[c]; }); }
  function midnight(d) { return new Date(d.getFullYear(), d.getMonth(), d.getDate()); }
  function sameDay(a, b) { return a.getFullYear() === b.getFullYear() && a.getMonth() === b.getMonth() && a.getDate() === b.getDate(); }

  var ev = data.map(function (r) {
    var tags = Array.isArray(r.tags) ? r.tags : (r.tags ? String(r.tags).split(',') : []);
    var e = { id: r.id, title: r.title || '', time: r.time || '', desc: r.desc || '', img: r.img || '', url: r.url || '', btn: r.btn || '', price: r.price || '', status: r.status || '', label: r.label || '', icon: (r.icon || '').toLowerCase(), tags: tags.map(function (t) { return String(t).trim(); }).filter(Boolean) };
    e.v = VEN[String(r.venue || '').toLowerCase()] || NONE;
    var d = /^(\d{4})-(\d{2})-(\d{2})$/.exec(r.date || '');
    if (d) { e.kind = 'dated'; e.day = new Date(+d[1], +d[2] - 1, +d[3]); }
    else if (r.day && DOW[String(r.day).toLowerCase()] !== undefined) { e.kind = 'weekly'; e.dow = DOW[String(r.day).toLowerCase()]; }
    else if (/^every/i.test(e.label)) { e.kind = 'weekly'; e.dow = null; }
    else e.kind = 'soon';
    e.out = /sold out/i.test(e.status);
    return e;
  }).filter(function (e) { return e.title; });

  var now0 = new Date();
  var state = { f: 'all', v: 'list', y: now0.getFullYear(), m: now0.getMonth(), sel: null };
  function passes(e) { return state.f === 'all' || e.v.key === state.f || e.v.key === 'both' || e.v.key === 'none'; }
  function rel(day) {
    var n = Math.round((day - midnight(new Date())) / 86400000);
    if (n === 0) return 'Today';
    if (n === 1) return 'Tomorrow';
    if (n < 7) return 'This ' + DAYS[day.getDay()];
    if (n < 14) return 'Next ' + DAYS[day.getDay()];
    return 'In ' + n + ' days';
  }
  function cs(e) { return ' style="--c:' + e.v.c + ';--cink:' + e.v.ink + '"'; }
  function bigdate(day) { return '<div class="hke-bigdate"><small>' + DAYS[day.getDay()].slice(0, 3) + '</small><b>' + day.getDate() + '</b><small>' + MONTHS[day.getMonth()].slice(0, 3) + '</small></div>'; }

  // time parsing for calendar files: "7pm", "7:30pm", "18:00", "7pm to 8:30pm", "6:30am - 8am"
  function parseT(s) {
    var m = /(\d{1,2})(?:[:.](\d{2}))?\s*(am|pm)?/i.exec(s || '');
    if (!m) return null;
    var h = +m[1], mi = +(m[2] || 0), ap = (m[3] || '').toLowerCase();
    if (ap === 'pm' && h < 12) h += 12;
    if (ap === 'am' && h === 12) h = 0;
    if (h > 23 || mi > 59) return null;
    return [h, mi];
  }
  function pad(n) { return (n < 10 ? '0' : '') + n; }
  function stamp(d, t) { return d.getFullYear() + pad(d.getMonth() + 1) + pad(d.getDate()) + (t ? 'T' + pad(t[0]) + pad(t[1]) + '00' : ''); }
  function ics(e) {
    var parts = (e.time || '').split(/\s*(?:to|-|–|until)\s*/i);
    var st = parseT(parts[0]), en = parseT(parts[1]);
    var lines = ['BEGIN:VCALENDAR', 'VERSION:2.0', 'PRODID:-//Hikitalo//Events//EN', 'BEGIN:VEVENT', 'UID:' + e.id + '@hikitalo.com', 'DTSTAMP:' + stamp(new Date(), [new Date().getHours(), new Date().getMinutes()])];
    if (st) {
      if (!en) { var end = new Date(2000, 0, 1, st[0], st[1] + 60); en = [end.getHours(), end.getMinutes()]; }
      lines.push('DTSTART:' + stamp(e.day, st), 'DTEND:' + stamp(e.day, en));
    } else {
      var nx = new Date(e.day.getTime()); nx.setDate(nx.getDate() + 1);
      lines.push('DTSTART;VALUE=DATE:' + stamp(e.day), 'DTEND;VALUE=DATE:' + stamp(nx));
    }
    var link = location.origin + location.pathname + '#' + e.id;
    lines.push('SUMMARY:' + ('Hikitalo: ' + e.title).replace(/[,;]/g, '\\$&'));
    if (e.v.addr) lines.push('LOCATION:' + e.v.addr.replace(/[,;]/g, '\\$&'));
    lines.push('DESCRIPTION:' + (e.desc.replace(/\n/g, ' ') + ' ' + link).replace(/[,;]/g, '\\$&'), 'URL:' + link, 'END:VEVENT', 'END:VCALENDAR');
    var blob = new Blob([lines.join('\r\n')], { type: 'text/calendar' });
    var a = document.createElement('a');
    a.href = URL.createObjectURL(blob); a.download = 'hikitalo-' + e.id + '.ics';
    document.body.appendChild(a); a.click(); setTimeout(function () { URL.revokeObjectURL(a.href); a.remove(); }, 500);
  }
  var toastT;
  function toast(msg) { var t = document.getElementById('hke-toast'); t.textContent = msg; t.classList.add('on'); clearTimeout(toastT); toastT = setTimeout(function () { t.classList.remove('on'); }, 2200); }
  function share(e) {
    var link = location.origin + location.pathname + '#' + e.id;
    var text = e.title + (e.kind === 'dated' ? ', ' + DAYS[e.day.getDay()] + ' ' + e.day.getDate() + ' ' + MONTHS[e.day.getMonth()] : '') + ' at Hikitalo';
    if (navigator.share) { navigator.share({ title: e.title, text: text, url: link }).catch(function () {}); return; }
    if (navigator.clipboard) navigator.clipboard.writeText(link).then(function () { toast('Link copied. Send it to your mates.'); });
  }

  function meta(e) {
    var m = '';
    if (e.time) m += '<span>' + esc(e.time) + '</span>';
    if (e.v.name) m += '<span class="hke-pill">' + esc(e.v.name) + '</span>';
    if (e.price) m += '<span class="hke-price">' + esc(e.price) + '</span>';
    if (e.status) m += '<span class="hke-status' + (e.out ? ' out' : '') + '">' + esc(e.status) + '</span>';
    return m ? '<div class="hke-meta">' + m + '</div>' : '';
  }
  function actions(e) {
    var h = '';
    if (e.out) h += '<a class="hke-btn is-out" href="#hke-signup">Sold out. Get the next one</a>';
    else if (e.url) h += '<a class="hke-btn" href="' + esc(e.url) + '">' + esc(e.btn || 'Book now') + ' &rarr;</a>';
    if (e.kind === 'dated') h += '<button type="button" class="hke-ghost" data-ics="' + esc(e.id) + '" aria-label="Add ' + esc(e.title) + ' to your calendar">' + UI.cal + 'Add to calendar</button>';
    h += '<button type="button" class="hke-ghost" data-share="' + esc(e.id) + '" aria-label="Share ' + esc(e.title) + '">' + UI.share + 'Share</button>';
    return '<div class="hke-actions">' + h + '</div>';
  }
  function inner(e) {
    var h = meta(e);
    if (e.desc) h += '<p class="hke-desc">' + esc(e.desc) + '</p>';
    if (e.tags.length) h += '<div class="hke-tags">' + e.tags.map(function (t) { return '<span class="hke-tag">' + esc(t) + '</span>'; }).join('') + '</div>';
    return h + actions(e);
  }
  function whenLine(e) { return e.kind === 'dated' ? '<p class="hke-when">' + DAYS[e.day.getDay()] + ' ' + e.day.getDate() + ' ' + MONTHS[e.day.getMonth()] + '</p>' : ''; }

  function feature(e) {
    var media = e.img ? '<div class="hke-feat-media"><img src="' + esc(e.img) + '" alt="' + esc(e.title) + '" loading="eager">' + bigdate(e.day) + '</div>' : '<div class="hke-feat-media noimg">' + bigdate(e.day) + '</div>';
    return '<article class="hke-feat" id="' + esc(e.id) + '"' + cs(e) + '>' + media + '<div class="hke-feat-body"><span class="hke-next">Next up &middot; ' + rel(e.day) + '</span><h2>' + esc(e.title) + '</h2>' + whenLine(e) + inner(e) + '</div></article>';
  }
  function card(e) {
    var cls = 'hke-card' + (e.kind === 'soon' ? ' hke-soon' : '');
    var top = '';
    var media = '';
    if (e.img) media = '<div class="hke-media"><img src="' + esc(e.img) + '" alt="' + esc(e.title) + '" loading="lazy">' + (e.kind === 'dated' ? bigdate(e.day) : '') + '</div>';
    else media = '<div class="hke-band"></div>';
    var chip = e.kind === 'dated' ? '<span class="hke-rel">' + rel(e.day) + '</span>' : (e.kind === 'soon' ? '<span class="hke-rel">' + esc(e.label || 'Dates to be announced') + '</span>' : '');
    if (!e.img) top = '<div class="hke-top"><div class="hke-ic">' + icon(e.icon) + '</div>' + chip + '</div>';
    else if (chip) top = '<div class="hke-top" style="justify-content:flex-end">' + chip + '</div>';
    return '<article class="' + cls + '" id="' + esc(e.id) + '"' + cs(e) + '>' + media + '<div class="hke-body">' + top + '<h3>' + esc(e.title) + '</h3>' + whenLine(e) + inner(e) + '</div></article>';
  }
  function weekly(e) {
    return '<article class="hke-wk" id="' + esc(e.id) + '"' + cs(e) + '><div class="hke-wd">' + icon(e.icon) + '<small>Every</small><b>' + (e.dow === null ? 'Week' : DAYS[e.dow].slice(0, 3)) + '</b></div><div><h3>' + esc(e.title) + '</h3>' + inner(e) + '</div></article>';
  }

  function onDay(e, day) {
    if (day < midnight(new Date())) return false;
    if (e.kind === 'dated') return sameDay(e.day, day);
    if (e.kind === 'weekly') return e.dow !== null && day.getDay() === e.dow;
    return false;
  }
  function eventsOn(day) { return ev.filter(function (e) { return passes(e) && onDay(e, day); }); }

  function calView() {
    var first = new Date(state.y, state.m, 1), lead = (first.getDay() + 6) % 7, total = new Date(state.y, state.m + 1, 0).getDate();
    var cells = Math.ceil((lead + total) / 7) * 7, today = midnight(new Date());
    var atStart = state.y === today.getFullYear() && state.m === today.getMonth();
    var h = '<div class="hke-cal"><div class="hke-ct"><button type="button" class="hke-nav" data-nav="-1" aria-label="Previous month"' + (atStart ? ' disabled' : '') + '>&#8249;</button><h3>' + MONTHS[state.m] + ' ' + state.y + '</h3><button type="button" class="hke-nav" data-nav="1" aria-label="Next month">&#8250;</button></div><div class="hke-cg">';
    ['Mon', 'Tue', 'Wed', 'Thu', 'Fri', 'Sat', 'Sun'].forEach(function (d) { h += '<div class="hke-dn">' + d + '</div>'; });
    for (var i = 0; i < cells; i++) {
      var dn = i - lead + 1;
      if (dn < 1 || dn > total) { h += '<div class="hke-cd out"></div>'; continue; }
      var day = new Date(state.y, state.m, dn), list = eventsOn(day);
      var cls = 'hke-cd' + (day < today ? ' past' : '') + (sameDay(day, today) ? ' today' : '') + (list.length ? ' has' : '') + (state.sel && sameDay(day, state.sel) ? ' sel' : '');
      var c = '<span class="n">' + dn + '</span>';
      list.forEach(function (e) { c += '<span class="hke-ep"' + cs(e) + '>' + esc(e.title) + '</span>'; });
      h += list.length ? '<button type="button" class="' + cls + '" data-day="' + state.y + '-' + state.m + '-' + dn + '" aria-label="' + dn + ' ' + MONTHS[state.m] + ', ' + list.length + ' event' + (list.length > 1 ? 's' : '') + '">' + c + '</button>' : '<div class="' + cls + '">' + c + '</div>';
    }
    h += '</div><div class="hke-key"><span><i style="background:#db673a"></i>Cardiff</span><span><i style="background:#4a9060"></i>Sandy Bay</span><span><i style="background:#fbbf39"></i>Both venues</span></div></div><div class="hke-panel">';
    if (state.sel) {
      var sel = eventsOn(state.sel);
      h += '<div class="hke-h">' + DAYS[state.sel.getDay()] + ' ' + state.sel.getDate() + ' ' + MONTHS[state.sel.getMonth()] + '</div>';
      sel.forEach(function (e) { h += e.kind === 'weekly' ? weekly(e) : card(e); });
      if (!sel.length) h += '<p class="hke-hint">Nothing on this day.</p>';
    } else h += '<p class="hke-hint">Tap a highlighted day to see what’s on.</p>';
    h += '</div>';
    var wkx = ev.filter(function (e) { return passes(e) && e.kind === 'weekly' && e.dow === null; });
    if (wkx.length) { h += '<div class="hke-h">Every week</div>'; wkx.forEach(function (e) { h += weekly(e); }); }
    var soon = ev.filter(function (e) { return passes(e) && e.kind === 'soon'; });
    if (soon.length) { h += '<div class="hke-h">Keep an eye out</div><div class="hke-grid">'; soon.forEach(function (e) { h += card(e); }); h += '</div>'; }
    return h;
  }

  function listView() {
    var dated = [], wk = [], soon = [];
    ev.forEach(function (e) {
      if (!passes(e)) return;
      if (e.kind === 'dated') { if (e.day >= midnight(new Date())) dated.push(e); }
      else if (e.kind === 'weekly') wk.push(e); else soon.push(e);
    });
    dated.sort(function (a, b) { return a.day - b.day; });
    wk.sort(function (a, b) { return (a.dow === null ? 7 : (a.dow + 6) % 7) - (b.dow === null ? 7 : (b.dow + 6) % 7); });
    if (!dated.length && !wk.length && !soon.length) return '<div class="hke-empty"><p>Nothing on the board ' + (state.f === 'all' ? 'just yet' : 'here just yet') + '. Pop your email in below and we’ll tell you the moment new dates drop.</p></div>';
    var h = '';
    if (dated.length) {
      h += feature(dated[0]);
      if (dated.length > 1) { h += '<div class="hke-h">Coming up</div><div class="hke-grid">'; dated.slice(1).forEach(function (e) { h += card(e); }); h += '</div>'; }
    }
    if (wk.length) { h += '<div class="hke-h">Every week</div>'; wk.forEach(function (e) { h += weekly(e); }); }
    if (soon.length) { h += '<div class="hke-h">Keep an eye out</div><div class="hke-grid">'; soon.forEach(function (e) { h += card(e); }); h += '</div>'; }
    return h;
  }

  function counts() {
    var el = document.getElementById('hke-count');
    var d = ev.filter(function (e) { return e.kind === 'dated'; }).length, w = ev.filter(function (e) { return e.kind === 'weekly'; }).length;
    var h = '';
    if (d) h += '<span><b>' + d + '</b> coming up</span>';
    if (w) h += '<span><b>' + w + '</b> every week</span>';
    if (h) { el.innerHTML = h; el.hidden = false; }
  }
  function sync() {
    Array.prototype.forEach.call(root.querySelectorAll('[data-f]'), function (b) { b.setAttribute('aria-pressed', b.getAttribute('data-f') === state.f ? 'true' : 'false'); });
    Array.prototype.forEach.call(root.querySelectorAll('[data-v]'), function (b) { b.setAttribute('aria-pressed', b.getAttribute('data-v') === state.v ? 'true' : 'false'); });
  }
  function render() { out.innerHTML = state.v === 'cal' ? calView() : listView(); sync(); }
  function byId(id) { for (var i = 0; i < ev.length; i++) if (ev[i].id === id) return ev[i]; return null; }

  root.addEventListener('click', function (x) {
    var b = x.target.closest('button');
    if (!b || !root.contains(b)) return;
    if (b.hasAttribute('data-f')) { state.f = b.getAttribute('data-f'); state.sel = null; render(); }
    else if (b.hasAttribute('data-v')) { state.v = b.getAttribute('data-v'); render(); }
    else if (b.hasAttribute('data-nav')) { var d = new Date(state.y, state.m + parseInt(b.getAttribute('data-nav'), 10), 1); state.y = d.getFullYear(); state.m = d.getMonth(); state.sel = null; render(); }
    else if (b.hasAttribute('data-day')) {
      var p = b.getAttribute('data-day').split('-'); state.sel = new Date(+p[0], +p[1], +p[2]); render();
      var panel = root.querySelector('.hke-panel'); if (panel) panel.scrollIntoView({ behavior: 'smooth', block: 'start' });
    }
    else if (b.hasAttribute('data-ics')) { var e1 = byId(b.getAttribute('data-ics')); if (e1) ics(e1); }
    else if (b.hasAttribute('data-share')) { var e2 = byId(b.getAttribute('data-share')); if (e2) share(e2); }
  });

  counts();
  render();

  // deep link: hikitalo.com/pages/events#event-handle
  if (location.hash.length > 1) {
    var t = document.getElementById(decodeURIComponent(location.hash.slice(1)));
    if (t && root.contains(t)) { t.classList.add('is-target'); setTimeout(function () { t.scrollIntoView({ behavior: 'smooth', block: 'start' }); }, 150); }
  }
  if (document.querySelector('#hke-signup .hke-ok, #hke-signup .hke-err')) document.getElementById('hke-signup').scrollIntoView({ block: 'center' });
})();
